<div class="calculator-overlay">
  <mat-form-field appearance="outline" class="calculator-input">
    <mat-label>Beregning</mat-label>
    <input matInput type="text" [(ngModel)]="expression" (ngModelChange)="onExpressionChange()" (keydown.enter)="apply()" (keydown.escape)="dismiss()" #expressionInput>
  </mat-form-field>
  <div class="calculator-result" [class.has-result]="result !== null" [class.stale-result]="result === null && lastValidResult !== null">
    @if (displayValue !== null) {
      = {{ displayValue | number:'1.0-2':'da' }}
    } @else {
      &nbsp;
    }
  </div>
  <button mat-raised-button color="primary" [disabled]="result === null" (click)="apply()">Anvend</button>
</div>
